import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import { useDialog } from '@/components/Molecules/Dialog/Dialog';
import { SaveButton } from '@/components/Molecules/SaveButton/SaveButton';
import { EmailModal } from '@/components/Organisms/EmailModal/EmailModal';
import useTranslation from '@/hooks/useTranslation';
import type { IShortDetail } from '@/interfaces';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import ArrowRightIcon from '@bloomberg/web-icons-react/ArrowRight';
import EnvelopeIcon from '@bloomberg/web-icons-react/Envelope';
import type { ReactNode } from 'react';
import { Fragment } from 'react';
export const useShortsActions = short => {
  const $ = _c(59);
  const emailDialog = useDialog();
  const {
    t
  } = useTranslation("shorts");
  let t0;
  if ($[0] !== short.id || $[1] !== short.title || $[2] !== short.type) {
    t0 = <SaveButton key="save" id={short.id} type={short.type} itemName={short.title} />;
    $[0] = short.id;
    $[1] = short.title;
    $[2] = short.type;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== emailDialog) {
    t1 = () => emailDialog.open();
    $[4] = emailDialog;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EnvelopeIcon />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("common:Actions.send_email");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <Button kind="tertiary" onClick={t1} icon={t2}>{t3}</Button>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = `/shorts/${short.id}/send_email`;
  let t6;
  if ($[12] !== t5) {
    t6 = {
      apiUrl: t5
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== emailDialog || $[15] !== t6) {
    t7 = <EmailModal dialog={emailDialog} form={t6} />;
    $[14] = emailDialog;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t7) {
    t8 = <Fragment key="email">{t4}{t7}</Fragment>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let actions;
  if ($[20] !== short.parentCountryProfile || $[21] !== short.parentInsightNote || $[22] !== short.parentInteractiveDataset || $[23] !== short.parentNewsStory || $[24] !== short.parentTheme || $[25] !== t || $[26] !== t0 || $[27] !== t8) {
    actions = [t0, t8];
    if (short.parentInsightNote) {
      const t9 = short.parentInsightNote.url;
      let t10;
      if ($[29] !== t) {
        t10 = t("shorts:sideBarActions.relatedInsight");
        $[29] = t;
        $[30] = t10;
      } else {
        t10 = $[30];
      }
      let t11;
      if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = <ArrowRightIcon />;
        $[31] = t11;
      } else {
        t11 = $[31];
      }
      let t12;
      if ($[32] !== short.parentInsightNote.url || $[33] !== t10) {
        t12 = <SideBarButton key="insight" url={t9} text={t10} icon={t11} />;
        $[32] = short.parentInsightNote.url;
        $[33] = t10;
        $[34] = t12;
      } else {
        t12 = $[34];
      }
      actions.push(t12);
    }
    if (short.parentCountryProfile) {
      const t9 = short.parentCountryProfile.url;
      let t10;
      if ($[35] !== t) {
        t10 = t("shorts:sideBarActions.relatedTool");
        $[35] = t;
        $[36] = t10;
      } else {
        t10 = $[36];
      }
      let t11;
      if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = <ArrowRightIcon />;
        $[37] = t11;
      } else {
        t11 = $[37];
      }
      let t12;
      if ($[38] !== short.parentCountryProfile.url || $[39] !== t10) {
        t12 = <SideBarButton key="country" url={t9} text={t10} icon={t11} />;
        $[38] = short.parentCountryProfile.url;
        $[39] = t10;
        $[40] = t12;
      } else {
        t12 = $[40];
      }
      actions.push(t12);
    }
    if (short.parentNewsStory) {
      const t9 = short.parentNewsStory.url;
      let t10;
      if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <ArrowRightIcon />;
        $[41] = t10;
      } else {
        t10 = $[41];
      }
      let t11;
      if ($[42] !== t) {
        t11 = t("shorts:sideBarActions.relatedNews");
        $[42] = t;
        $[43] = t11;
      } else {
        t11 = $[43];
      }
      let t12;
      if ($[44] !== short.parentNewsStory.url || $[45] !== t11) {
        t12 = <SideBarButton key="news" url={t9} icon={t10} text={t11} />;
        $[44] = short.parentNewsStory.url;
        $[45] = t11;
        $[46] = t12;
      } else {
        t12 = $[46];
      }
      actions.push(t12);
    }
    if (short.parentTheme) {
      const t9 = short.parentTheme.url;
      let t10;
      if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <ArrowRightIcon />;
        $[47] = t10;
      } else {
        t10 = $[47];
      }
      let t11;
      if ($[48] !== t) {
        t11 = t("shorts:sideBarActions.relatedTheme");
        $[48] = t;
        $[49] = t11;
      } else {
        t11 = $[49];
      }
      let t12;
      if ($[50] !== short.parentTheme.url || $[51] !== t11) {
        t12 = <SideBarButton key="theme" url={t9} icon={t10} text={t11} />;
        $[50] = short.parentTheme.url;
        $[51] = t11;
        $[52] = t12;
      } else {
        t12 = $[52];
      }
      actions.push(t12);
    }
    if (short.parentInteractiveDataset) {
      const t9 = short.parentInteractiveDataset.url;
      let t10;
      if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <ArrowRightIcon />;
        $[53] = t10;
      } else {
        t10 = $[53];
      }
      let t11;
      if ($[54] !== t) {
        t11 = t("shorts:sideBarActions.relatedTool");
        $[54] = t;
        $[55] = t11;
      } else {
        t11 = $[55];
      }
      let t12;
      if ($[56] !== short.parentInteractiveDataset.url || $[57] !== t11) {
        t12 = <SideBarButton key="dataset" url={t9} icon={t10} text={t11} />;
        $[56] = short.parentInteractiveDataset.url;
        $[57] = t11;
        $[58] = t12;
      } else {
        t12 = $[58];
      }
      actions.push(t12);
    }
    $[20] = short.parentCountryProfile;
    $[21] = short.parentInsightNote;
    $[22] = short.parentInteractiveDataset;
    $[23] = short.parentNewsStory;
    $[24] = short.parentTheme;
    $[25] = t;
    $[26] = t0;
    $[27] = t8;
    $[28] = actions;
  } else {
    actions = $[28];
  }
  return actions;
};
const SideBarButton = t0 => {
  const $ = _c(7);
  const {
    url,
    text,
    icon
  } = t0;
  const t1 = `Short: ${text}`;
  let t2;
  if ($[0] !== t1) {
    t2 = buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Attachment, t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== icon || $[3] !== t2 || $[4] !== text || $[5] !== url) {
    t3 = <Button icon={icon} kind="primary" href={url} data-analytics-tracking={t2}>{text}</Button>;
    $[2] = icon;
    $[3] = t2;
    $[4] = text;
    $[5] = url;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
interface ISideBarItem {
  url: string;
  text: string;
  icon: ReactNode;
}